import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useSnackBar } from '~/contexts/SnackBarContext.tsx';
import useIssuableCoupons from '~/hooks/useIssuableCoupons.ts';
import useUsableCoupons from '~/hooks/useUsableCoupons.ts';
import { getIssuableCoupons, issueCoupon } from '~kup/controllers/coupon.ts';
import useBatchLogger from '~/hooks/useBatchLogger.ts';

export default function useCouponHelper(productItemIds: string[]) {
  const { i18n } = useTranslation();
  const { logAction } = useBatchLogger();
  const [refresh, setRefresh] = useState<number>(Date.now());
  const { showSnackBar } = useSnackBar();

  const { trueIssuableCoupons } = useIssuableCoupons(refresh);
  const { usableCoupons } = useUsableCoupons(productItemIds, refresh);
  const bestUsableCoupon =
    usableCoupons.length > 0
      ? usableCoupons.reduce((bestCoupon, coupon) => {
          if ((coupon.applicableDiscountAmount ?? 0) > (bestCoupon.applicableDiscountAmount ?? 0))
            return coupon;
          return bestCoupon;
        })
      : null;

  const handleIssueCoupons = async () => {
    if (!trueIssuableCoupons || trueIssuableCoupons.length === 0) return;
    Promise.all(
      trueIssuableCoupons.map((coupon) => {
        issueCoupon(coupon.id).then(() => {
          return getIssuableCoupons({ onTour: true });
        });
      })
    ).then(() => {
      showSnackBar({
        message: i18n.t('shop-product-coupon-issued'),
        lift: true,
      });

      logAction({
        eventType: 'CLICK',
        eventTarget: 'CLAIM_COUPON',
        eventCategory: 'coupon',
      });
      setRefresh(Date.now());
    });
  };
  return {
    issuableCoupons: trueIssuableCoupons,
    bestUsableCoupon,
    handleIssueCoupons,
  };
}
